import { IErrorHandler } from '../services/ErrorHandler/IErrorHandler';
import { CognitoHttpClient } from '../services/HttpClient/CognitoHttpClient';
import { UmmyHttpClient } from '../services/HttpClient/UmmyHttpClient';
import {
  IStorageProvider,
  StorageKeys,
} from '../services/StorageProvider/IStorageProvider';
import { CompanyActionApi } from './companyAction/CompanyActionApi';
import { ICompanyActionApi } from './companyAction/ICompanyActionApi';
import { AuthorizationApi } from './authorization/AuthorizationApi';
import { IAuthorizationApi } from './authorization/IAuthorizationApi';
import { CompanyApi } from './company/CompanyApi';
import { ICompanyApi } from './company/ICompanyApi';
import { FeedbackApi } from './feedback/FeedbackApi';
import { IFeedbackApi } from './feedback/IFeedbackApi';
import { GamificationApi } from './gamification/GamificationApi';
import { IGamificationApi } from './gamification/IGamificationApi';
import { ITeamApi } from './team/ITeamApi';
import { TeamApi } from './team/TeamApi';
import { IUserApi } from './user/IUserApi';
import { UserApi } from './user/UserApi';
import { AlertsApi } from './alerts/AlertsApi';
import { IAlertsApi } from './alerts/IAlertsApi';
import { ILumiaApi } from './lumia/ILumiaApi';
import { LumiaApi } from './lumia/LumiaApi';
import { LumiaApi2 } from './lumia/LumiaApi2';

export type CreateApiParams = {
  baseUrl: string;
  errorHandler: IErrorHandler;
  storageProvider: IStorageProvider;
  onAuthenticationFailed: () => void;
};

export const createApi = async ({
  baseUrl,
  errorHandler,
  storageProvider,
  onAuthenticationFailed,
}: CreateApiParams) => {
  const accessToken: string | null = await storageProvider.getItem(
    StorageKeys.ACCESS_TOKEN_KEY
  );
  const refreshToken: string | null = await storageProvider.getItem(
    StorageKeys.REFRESH_TOKEN_KEY
  );

  const ummyHttpClient = new UmmyHttpClient({
    baseUrl,
    errorHandler,
    accessToken,
    refreshToken,
    onAuthenticationFailed
  });

  // HttpClient specifico per lumiaApi2 con nuovo URL
  const lumia2HttpClient = new UmmyHttpClient({
    baseUrl: 'https://mg0lulmfaf.execute-api.eu-central-1.amazonaws.com/dev',
    errorHandler,
    accessToken,
    refreshToken,
    onAuthenticationFailed
  });

  const cognitoHttpClient = new CognitoHttpClient({
    errorHandler,
  });

  const authorizationApi: IAuthorizationApi = new AuthorizationApi(
    cognitoHttpClient,
    [ummyHttpClient, lumia2HttpClient],
    storageProvider,
    onAuthenticationFailed
  );

  const userApi: IUserApi = new UserApi(ummyHttpClient);
  const companyApi: ICompanyApi = new CompanyApi(ummyHttpClient);
  const companyActionApi: ICompanyActionApi = new CompanyActionApi(
    ummyHttpClient
  );
  const teamApi: ITeamApi = new TeamApi(ummyHttpClient);
  const feedbackApi: IFeedbackApi = new FeedbackApi(ummyHttpClient);
  const gamificationApi: IGamificationApi = new GamificationApi(ummyHttpClient);
  const alertApi: IAlertsApi = new AlertsApi(ummyHttpClient);
  const lumiaApi: ILumiaApi = new LumiaApi(ummyHttpClient);
  const lumiaApi2: ILumiaApi = new LumiaApi2(lumia2HttpClient);

  return {
    authorization: authorizationApi,
    userApi,
    companyApi,
    teamApi,
    feedbackApi,
    gamificationApi,
    companyActionApi,
    alertApi,
    lumiaApi,
    lumiaApi2,
  };
};
